import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Button from "../../../../components/Common/Button/Button";
import Input from "../../../../components/Common/Input/Input";
import Loader from "../../../../components/Common/Loader/Loader";
import { getSearchShotclassesActionHandler } from "../../../../store/actions/actionHandlers/distributeActionHandler";
import SearchSuggestionInput from "../../../AdminPage/GroupManagement/ManageGroup/SearchSuggestionInput/SearchSuggestionInput";
import classes from "./RecallShotclassesForm.module.scss";
import { dateFormatyyyymmdd } from "../../../SocialPage/PollManagement/DistributePoll/DistributePollForm/DistributePollForm";
import { FormattedMessage } from "react-intl";
import RecallShotclassesTable from "../RecallShotclassesTable/RecallShotclassesTable";

const RecallShotclassesForm = ({
  selectedSearchShotclassData,
  setselectedSearchShotclassData,
  tenantName,
  setSelectedUserClassAndNameObj,
  selectedUserClassAndNameObj,
  recallShotclassesSearchClick,
  setRecallShotclassesSearchClick,
}) => {
  const dispatch = useDispatch();
  const [fromMaxDate, setFromMaxDate] = useState(
    dateFormatyyyymmdd(new Date())
  );
  const [toMinDate, setToMinDate] = useState(null);
  const [searchShotclassesData, setsearchShotclassesData] = useState([]);
  const [searchLoader, setSearchLoader] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const methods = useForm({
    defaultValues: {
      fromDate: selectedUserClassAndNameObj?.class?.fromDate,
      toDate: selectedUserClassAndNameObj?.class?.toDate,
    },
  });
  const { setValue } = methods;

  const handleFromDate = (e) => {
    setFromDate(e.target.value);
    setSelectedUserClassAndNameObj((prev) => {
      return {
        ...prev,
        class: {
          ...prev?.class,
          fromDate: e.target.value,
          type: "class",
        },
      };
    });
    if (e.target.value) setToMinDate(e.target.value);
    else setToMinDate(null);
  };

  const handleToDate = (e) => {
    setToDate(e.target.value);
    setSelectedUserClassAndNameObj((prev) => {
      return {
        ...prev,
        class: {
          ...prev?.class,
          toDate: e.target.value,
          type: "class",
        },
      };
    });
    if (e.target.value) setFromMaxDate(e.target.value);
    else setFromMaxDate(null);
  };

  const handleSearch = (e) => {
    const val = e?.target?.value?.trim();
    if (e?.target?.value?.trim()) {
      dispatch(
        getSearchShotclassesActionHandler(
          true,
          2,
          val,
          "Published",
          setsearchShotclassesData,
          setSearchLoader
        )
      );
    } else {
      setsearchShotclassesData([]);
      setSelectedUserClassAndNameObj((prev) => {
        return {
          ...prev,
          class: {
            ...prev?.class,
            classId: 0,
            userId: 0,
          },
        };
      });
    }
  };

  const onDropdownOptionClick = (data) => {
    setselectedSearchShotclassData(data);
    setsearchShotclassesData([]);
    setValue("className", data?.Name);
    setSelectedUserClassAndNameObj({
      class: {
        className: data?.Name,
        classId: data?.ID,
        userId: 0,
        fromDate: fromDate,
        toDate: toDate,
        type: "class",
      },
    });
  };

  const handleResetClick = () => {
    setValue("fromDate", null);
    setValue("toDate", null);
    setValue("className", null);
    setFromDate(null);
    setToDate(null);
    setselectedSearchShotclassData(null);
    setRecallShotclassesSearchClick(0);
    setSelectedUserClassAndNameObj({
      class: {
        classId: 0,
        userId: 0,
      },
    });
    setFromMaxDate(dateFormatyyyymmdd(new Date()));
    setToMinDate(null);
    setToMinDate(null);
  };

  const handleSearchClick = () => {
    setRecallShotclassesSearchClick((prev) => prev + 1);
  };

  useEffect(() => {
    if (selectedUserClassAndNameObj?.class?.classId) {
      console.log(selectedUserClassAndNameObj?.class?.classId);
      setValue("className", selectedUserClassAndNameObj?.class?.className);
    }
  }, []);

  return (
    <div className={classes.recallSotclasses}>
      <div className={classes.recallShotclassesForm}>
        <FormProvider {...methods}>
          <Input
            type="date"
            name="fromDate"
            label="Assignment From Date"
            labelColor="light"
            borderRadius={1}
            height={5}
            width={20}
            max={fromMaxDate}
            onChange={handleFromDate}
            onKeyDown={() => {
              return false;
            }}
          />
          <div className={classes.dashLine}>-</div>
          <Input
            type="date"
            name="toDate"
            label="Assignment To Date"
            labelColor="light"
            borderRadius={1}
            height={5}
            width={20}
            min={toMinDate}
            max={dateFormatyyyymmdd(new Date())}
            onChange={handleToDate}
            onKeyDown={() => {
              return false;
            }}
          />
          <div className={classes.search}>
            <SearchSuggestionInput
              label={<FormattedMessage id="CLASS_NAME_TEXT" />}
              name={"className"}
              placeholder={"Enter Shotclass Name To Recall"}
              search={false}
              height="5"
              gap="1"
              onChange={handleSearch}
              suggestionData={searchShotclassesData}
              onDropdownOptionClick={onDropdownOptionClick}
            />
            {searchLoader && (
              <div className={classes.loader}>
                <Loader height="40%" />
              </div>
            )}
          </div>
          <div className={classes.btn}>
            <Button
              type="submit"
              label={<FormattedMessage id="P_Search" />}
              dark
              width="11"
              height="5"
              disabled={
                !(
                  (fromDate && toDate) ||
                  (selectedUserClassAndNameObj?.class?.fromDate &&
                    selectedUserClassAndNameObj?.class?.toDate) ||
                  selectedSearchShotclassData
                )
              }
              onClick={handleSearchClick}
            />
            <Button
              label={<FormattedMessage id="RESET_MSG" />}
              dark
              width="11"
              height="5"
              disabled={
                !(
                  (fromDate && toDate) ||
                  (selectedUserClassAndNameObj?.class?.fromDate &&
                    selectedUserClassAndNameObj?.class?.toDate) ||
                  selectedSearchShotclassData
                )
              }
              onClick={handleResetClick}
            />
          </div>
        </FormProvider>
      </div>
      {recallShotclassesSearchClick > 0 && (
        <RecallShotclassesTable
          fromDate={fromDate}
          toDate={toDate}
          tenantName={tenantName}
          searchClick={recallShotclassesSearchClick}
          selectedUserClassAndNameObj={selectedUserClassAndNameObj}
          setSelectedUserClassAndNameObj={setSelectedUserClassAndNameObj}
        />
      )}
    </div>
  );
};

export default RecallShotclassesForm;
